import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

export default class ThemeSwitch extends PureComponent {
  static contextTypes = {
    themes: PropTypes.object.isRequired,
  };

  static childContextTypes = {
    themes: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    /**
     * Форкаем тему чтоб все изменения применяемые к ней не отражались на родительский
     * инстанс темы.
     */
    const themes = this.context.themes.fork();

    // Конфигурируем тему в соответсвии с изначальным значением пропса `name`.
    themes.use(this.props.name);

    this.state = { themes };
  }

  getChildContext() {
    return {
      themes: this.state.themes,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.name !== this.props.name) {
      this.state.themes.use(this.props.name);
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.children}
      </Fragment>
    );
  }
}

ThemeSwitch.propTypes = {
  /**
   * Имя темы на которую должны переключиться вложенные компоненты.
   */
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
};
